import React from 'react';
import PropTypes from 'prop-types';
import StripeCardProp from '../../propTypes/StripeCardProp';
import { compose } from '../../../../services/utilityFunctions';
import { useCards } from '../../../../services/customHooks';
import withCSRF from '../../../../commonComponents/withCSRF';
import translate from '../../../../commonComponents/translate';
import FormHeader from '../../../../commonComponents/forms/FormHeader';
import CreditCardList from '../../../../commonComponents/modal/components/CreditCardList';

/**
 * Form to update the current logged user's credit card information.
 *
 * Uses the same card list UI as the order checkout (CreditCardList). Selecting a
 * card sets it as the default; removing the default/last card is allowed here
 * (unlike the purchase/selection modals) and is gated behind a confirmation
 * dialog. Cards tied to an active subscription are rejected by the backend.
 */
function PaymentForm({ t, _csrf, cards: propCards, onCardsChange, fromSubscriptionOrders }) {
  const { cards, handleAddCard, handleRemoveCard, handleSelectCard } = useCards(
    _csrf,
    'credit-card-container',
    propCards,
    onCardsChange,
  );

  const defaultCard = cards.find(c => c.isDefault);

  return (
    <>
      <div
        className="m-form m-form--fit m-form--label-align-right"
        id="credit-card-container"
      >
        <div className="m-portlet__body">
          {
            !fromSubscriptionOrders && (
              <FormHeader title={`${t('payment_info')}`} />
            )
          }
          <div className="payment-methods-checkout profile-payment-methods">
            <CreditCardList
              cards={cards}
              selectedCreditCard={defaultCard ? defaultCard.id : ''}
              onSelectCard={card => handleSelectCard(card.id)}
              onRemoveCard={handleRemoveCard}
              onAddCard={handleAddCard}
              confirmOnRemove
              removeConfirmTitle={t('confirm_card_removal')}
              removeConfirmText={t('confirm_card_removal_message')}
            />
          </div>
        </div>
      </div>
    </>
  );
}

PaymentForm.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(StripeCardProp.propType)).isRequired,
  onCardsChange: PropTypes.func.isRequired,
  fromSubscriptionOrders: PropTypes.bool,
};
PaymentForm.defaultProps = {
  fromSubscriptionOrders: false,
};

export default compose(
  withCSRF,
  translate,
)(PaymentForm);
